import { useEffect, useState } from "react";
import { Trophy, Flame, Crown } from "lucide-react";
import { getReferralLeaderboard } from "@/lib/api";

const medal = (rank) => {
  if (rank === 1) return "🥇";
  if (rank === 2) return "🥈";
  if (rank === 3) return "🥉";
  return null;
};

export const ReferralLeaderboard = () => {
  const [board, setBoard] = useState(null);

  useEffect(() => {
    getReferralLeaderboard().then(setBoard).catch(() => setBoard(false));
  }, []);

  if (board === null || board === false) return null;

  const empty = !board.top || board.top.length === 0;

  return (
    <div data-testid="referral-leaderboard" className="rounded-2xl border border-border bg-card p-6">
      <div className="flex items-start gap-3">
        <span className="grid place-items-center h-10 w-10 rounded-xl bg-accent/15 text-accent shrink-0">
          <Trophy className="h-5 w-5" />
        </span>
        <div className="flex-1">
          <h3 className="font-serif text-xl font-bold">Top Inviters — {board.month}</h3>
          <p className="mt-1 text-sm text-muted-foreground">
            Every invited friend who makes their first lecture bumps you up the board and earns you 30 days of Pro.
          </p>
        </div>
      </div>

      {empty ? (
        <div className="mt-5 rounded-xl border border-dashed border-border bg-secondary/40 px-4 py-6 text-center text-sm text-muted-foreground">
          <Flame className="h-5 w-5 mx-auto text-accent mb-2" />
          Be the first to invite a friend this month — your name goes at the top.
        </div>
      ) : (
        <ol className="mt-5 divide-y divide-border">
          {board.top.map((row) => {
            const emoji = medal(row.rank);
            return (
              <li
                key={row.rank + "-" + row.user_id}
                data-testid={`leaderboard-row-${row.rank}`}
                className={`flex items-center gap-3 py-3 ${row.is_me ? "bg-accent/5 -mx-2 px-2 rounded-lg" : ""}`}
              >
                <span className={`grid place-items-center h-8 w-8 rounded-full text-sm font-bold shrink-0 ${
                  row.rank <= 3 ? "bg-accent/15 text-accent" : "bg-secondary text-muted-foreground"
                }`}>
                  {emoji || row.rank}
                </span>
                <span className="flex-1 font-semibold truncate">
                  {row.display_name}
                  {row.is_me && <span className="ml-2 text-xs text-accent uppercase tracking-wider font-bold">you</span>}
                </span>
                <span className="flex items-center gap-1 text-sm font-semibold text-muted-foreground">
                  <Flame className="h-4 w-4 text-accent" />
                  {row.count} <span className="text-xs font-normal">invited</span>
                </span>
              </li>
            );
          })}
        </ol>
      )}

      {board.me && (
        <div data-testid="leaderboard-me-row" className="mt-4 flex items-center gap-3 rounded-xl border border-accent/40 bg-accent/10 px-3 py-2.5">
          <span className="grid place-items-center h-8 w-8 rounded-full bg-accent/25 text-accent text-sm font-bold shrink-0">
            {board.me.rank}
          </span>
          <span className="flex-1 font-semibold truncate">
            <Crown className="inline h-3.5 w-3.5 text-accent mr-1 align-[-2px]" />
            You — {board.me.display_name}
          </span>
          <span className="flex items-center gap-1 text-sm font-semibold">
            <Flame className="h-4 w-4 text-accent" />
            {board.me.count}
          </span>
        </div>
      )}
    </div>
  );
};
